import React, { useEffect } from 'react';
import { Provider } from 'react-redux';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import Channels from 'pages/Channels';
import IframePlaceholder from 'pages/Channels/IframePlaceholder';
import Combinations from 'pages/Combinations/Combinations';
import Filters from 'pages/Filters/Filters';
import Home from 'pages/Home/Home';
import Modules from 'pages/Modules/Modules';
import 'react-toastify/dist/ReactToastify.css';
import Simulation from 'pages/Simulation';
import store from 'store';
import { AppRoute } from 'types';
import { setVeevaDomain } from 'utils/sessionStorage';
import AuthProvider from './pages/AuthProvider';

const App: React.FC = () => {
  const searchParams = new URLSearchParams(window.location.search);
  const veevaDomain = searchParams.get('source');

  useEffect(() => {
    if (veevaDomain) {
      setVeevaDomain(veevaDomain);
    }
  }, [veevaDomain]);

  return (
    <Provider store={store}>
      <ToastContainer />
      <BrowserRouter>
        <AuthProvider>
          <Routes>
            <Route path={AppRoute.HOME} element={<Home />}/>
            <Route path={AppRoute.FILTERS} element={<Filters />}/>
            <Route path={AppRoute.MODULES} element={<Modules />}/>
            <Route path={AppRoute.COMBINATIONS} element={<Combinations />} />
            <Route path={AppRoute.CHANNELS} element={<Channels />} />
            <Route path={AppRoute.SIMULATION} element={<Simulation />} />
            <Route path={AppRoute.IFRAME_PLACEHOLDER} element={<IframePlaceholder />} />
          </Routes>
        </AuthProvider>
      </BrowserRouter>
    </Provider>
  );
};

export default App;
